import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: 675,
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
        borderRadius: 16
      },
      "& .MuiButton-containedSecondary": {
        minWidth: "160px"
      },
      "& .MuiDialog-paperWidthSm": {
        width: 420
      },
      "& .MuiDialogContent-root": {
        overflowY: "auto"
      }
    },
    dialogTitle: {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      padding: "1.6rem 2.4rem",
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      "& .MuiTypography-root": {
        color: "#FFFFFF",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }
    },
    flexCenter: {
      display: "flex",
      alignItems: "center"
    },
    flexEnd: {
      display: "flex",
      justifyContent: "end"
    },
    icon: {
      marginRight: "15px"
    },
    closeIcon: {
      cursor: "pointer",
      "& path": {
        stroke: "#FFFFFF"
      }
    },
    gridBox: {
      margin: 0,
      width: "100%"
    },
    required: {
      color: theme.palette.error.main,
      marginLeft: 1,
      "& :after": {
        content: "*"
      }
    },
    iconMail: {
      color: "#009FB8",
      display: "flex"
    },
    actionWrap: {
      borderTop: 0,
      paddingTop: 0,
      justifyContent: "space-between",
      "& .MuiButton-root": {
        flex: 1
      }
    },
    boxConfirmDesc: {
      padding: "13px 0 0 0",
      maxWidth: 327
    },
    boxConfirm: {
      minHeight: "auto",
      padding: "3.2rem 2.4rem !important"
    },
    boxSuccess: {
      display: "flex",
      padding: "3.2rem 2.4rem !important",
      flexDirection: "column",
      minHeight: "224px",
      justifyContent: "space-between"
    },
    contentTitle: {
      padding: "0.9rem 2.4rem",
      borderTopRightRadius: 8,
      borderTopLeftRadius: 8,
      background: "#EEEEEE"
    },
    contentEditor: {
      maxHeight: "300px",
      overflow: "auto",
      padding: "2.4rem"
    },
    contentBlock: {
      borderRadius: 8,
      border: `1px solid ${theme.palette.grey[400]}`
    }
  }),
  { name: "ModalSendMailNotRef" }
);

export default useStyles;
